export enum WorkFlowCreatorNodeType {

  Excel = 'EXCEL',

  Database = 'DATABASE',

  Email = 'EMAIL',

  Request = 'REQUEST',

  Message = 'MESSAGE',

  If = 'IF',

  ForEach = 'FOREACH',

  While = 'WHILE',

  Connection = "CONNECTION",

  Start = "START",

  End = "END",

  Code = "CODE",

  InnerFlow = "INNERFLOW"
}

